let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bSjyK"), load("j6IGj"), load("hlJc4"), load("6tWAg"), load("aOdaf")]).then(() => parcelRequire('fkfWe'));